import React, { useContext } from 'react'
import { Route, Redirect, RouteProps } from 'react-router-dom'
import { store } from '../../../store/store'

const PrivateRoute: React.FC<RouteProps> = ({ component, ...rest }) => {
  const {state} = useContext(store)
  const renderFn = (Component: any) => (props: RouteProps) => {
    return state.loggedIn ? (
      <Component {...props} />
    ) : (
      <Redirect
        to={{
          pathname: '/login',
          state: { from: props.location }
        }}
      />
    )
  }

  return <Route {...rest} render={renderFn(component)} />;
}

export default PrivateRoute
